import type React from "react";
import { Alert, Button } from "../../ds";
import type { ProbePhase } from "../../lib/hooks/useConfirmProbe";

// Der Zustand nach dem Anwenden auf Probe: Countdown, Bestätigung,
// Rollback-Meldung. Firewall und WireGuard-Uplink zeigen denselben Ablauf —
// section-spezifisch sind nur `hint` und `children`.

export function ProbeBanner({
  phase,
  secondsLeft,
  keeping,
  hint,
  onKeep,
  onDismiss,
  children,
}: {
  phase: ProbePhase;
  secondsLeft: number;
  keeping: boolean;
  /** Was der Bediener jetzt prüfen soll — je Sektion anders. */
  hint: React.ReactNode;
  onKeep: () => void;
  onDismiss: () => void;
  /** Zusatzinhalt über dem Hinweis (z.B. der neue WireGuard-Schlüssel). */
  children?: React.ReactNode;
}) {
  if (phase === "probe") {
    return (
      <Alert variant="warning" title={`Änderung aktiv — behalten? Rollback in ${secondsLeft} s`}>
        <div className="flex flex-col gap-3">
          {children}
          <div className="flex flex-wrap items-center justify-between gap-3">
            <span className="min-w-0 flex-1">{hint}</span>
            <Button variant="warning" iconName="check" loading={keeping} onClick={onKeep}>
              Behalten
            </Button>
          </div>
        </div>
      </Alert>
    );
  }
  if (phase === "kept") {
    return (
      <Alert variant="success" dismissible onDismiss={onDismiss}>
        Bestätigt — die Konfiguration wurde dauerhaft übernommen (uci commit).
      </Alert>
    );
  }
  if (phase === "reverted") {
    return (
      <Alert variant="danger" title="Automatisch zurückgerollt" dismissible onDismiss={onDismiss}>
        Es kam keine Bestätigung innerhalb der Frist — der Router hat die alte Konfiguration
        wiederhergestellt. Die Sektion wurde neu geladen.
      </Alert>
    );
  }
  return null;
}
